import * as React from 'react';

export function RydAudioInputSelector({
    selectedDeviceId,
    setSelectedDeviceId,
}: {
    selectedDeviceId: string,
    setSelectedDeviceId: (id: string) => void,
}) {

    const [devices, setDevices] = React.useState<MediaDeviceInfo[]>([]);


    // Enumerate audio input devices once permission is granted.
    React.useEffect(() => {
        const getDevices = async () => {
            try {
                // Request permission by capturing audio temporarily.
                await navigator.mediaDevices.getUserMedia({ audio: true });
                const allDevices = await navigator.mediaDevices.enumerateDevices();
                const audioDevices = allDevices; //.filter(device => device.kind === 'audioinput');
                setDevices(audioDevices);
                if (audioDevices.length && !selectedDeviceId) {
                    setSelectedDeviceId(audioDevices[0].deviceId);
                }
            } catch (err) {
                console.error('Error enumerating devices:', err);
            }
        };

        getDevices();
    }, [selectedDeviceId]);

    return (<div style={{ marginBottom: '20px' }}>
        <label htmlFor="micSelect">Choose a microphone: </label>
        <select
            id="micSelect"
            value={selectedDeviceId}
            onChange={e => setSelectedDeviceId(e.target.value)}
        >
            {devices.map((device, i) => (
                <option key={i} value={device.deviceId}>
                    {device.label || `Microphone ${device.deviceId}`}
                </option>
            ))}
        </select>
    </div>);
}